require("bootstrap");
require("./app");


require("@fancyapps/fancybox");
require("slick-carousel");

require("./icono_cercano");

function onScroll(event) {
    var scrollPos = $(document).scrollTop();
    $("#secciones a").each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (
            refElement.position().top - 100 <= scrollPos &&
            refElement.position().top + refElement.height() > scrollPos
        ) {
            $("#secciones a").removeClass("active");
            currLink.addClass("active");
        } else {
            // currLink.removeClass("active");
        }
    });
}
$(document).on("scroll", onScroll);

/* let slide_proyecto_actual = 0;
let z_index = -1;

for (let i = 0; i < slide_proyecto.length; i++) {
    const item = slide_proyecto[i];
    $("#slide-proyecto .fondo").append(
        $("<div>")
            .attr({
                class: "item item_" + i
            })
            .css("background-image", "url(" + item + ")")
    );
}
$("#slide-proyecto .fondo .item_0").css("opacity", 1);

$("#item-0").addClass("active");

$.muestraSlide = function() {
    $("#slide-proyecto .fondo .item").css("opacity", 0);
    $("#slide-proyecto .fondo .item_" + slide_proyecto_actual).css(
        "opacity",
        1
    );

    $("#slide-proyecto .dots a").removeClass("active");
    $("#item-" + slide_proyecto_actual).addClass("active");
};

setInterval(() => {
    if (slide_proyecto_actual == slide_proyecto.length - 1) {
        slide_proyecto_actual = 0;
    } else {
        slide_proyecto_actual++;
    }
    $.muestraSlide();
}, 5000);

$("#slide-proyecto .dots a").on("click", function(e) {
    e.preventDefault();
    var item = $(this).data("item");

    slide_proyecto_actual = item;
    $.muestraSlide();
}); */

// SLIDE
let slide_proyecto_actual = 0;
let z_index = -1;
for (let i = 0; i < slide_proyecto.length; i++) {
    const item = slide_proyecto[i];
    $("#slide-proyecto .fondo").append(
        $("<div>")
            .attr({
                class: "item item_" + i
            })
            .css("background-image", "url(" + item.img + ")")
    );

    $("#slide-proyecto .fondo-tablet").append(
        $("<div>")
            .attr({
                class: "item item_" + i
            })
            .css("background-image", "url(" + item.img_tablet + ")")
    );

    $("#slide-proyecto .fondo-phone").append(
        $("<div>")
            .attr({
                class: "item item_" + i
            })
            .css("background-image", "url(" + item.img_phone + ")")
    );
}
$("#slide-proyecto .fondo .item_0").css("opacity", 1);
$("#slide-proyecto .fondo-tablet .item_0").css("opacity", 1);
$("#slide-proyecto .fondo-phone .item_0").css("opacity", 1);

/* $("#slide-proyecto")
    .find(".logo")
    .html($("<img>").attr({ src: slide_proyecto[0].logo, class: "img-fluid" }));
$("#slide-proyecto")
    .find(".texto")
    .html(
        $("<img>").attr({ src: slide_proyecto[0].texto, class: "img-fluid" })
    ); */
$("#item-0").addClass("active");

$.muestraSlide = function () {
    /*  $("#slide-proyecto")
        .find(".logo")
        .fadeOut(function() {
            $(this)
                .html(
                    $("<img>").attr({
                        src: slide_proyecto[slide_proyecto_actual].logo,
                        class: "img-fluid"
                    })
                )
                .fadeIn("slow");
        });
    $("#slide-proyecto")
        .find(".texto")
        .fadeOut(function() {
            $(this)
                .html(
                    $("<img>").attr({
                        src: slide_proyecto[slide_proyecto_actual].texto,
                        class: "img-fluid"
                    })
                )
                .fadeIn();
        }); */
    $("#slide-proyecto .fondo .item").css("opacity", 0);
    $("#slide-proyecto .fondo .item_" + slide_proyecto_actual).css(
        "opacity",
        1
    );
    $("#slide-proyecto .fondo-tablet .item").css("opacity", 0);
    $("#slide-proyecto .fondo-tablet .item_" + slide_proyecto_actual).css(
        "opacity",
        1
    );
    $("#slide-proyecto .fondo-phone .item").css("opacity", 0);
    $("#slide-proyecto .fondo-phone .item_" + slide_proyecto_actual).css(
        "opacity",
        1
    );

    $("#slide-proyecto .dots a").removeClass("active");
    $("#item-" + slide_proyecto_actual).addClass("active");
};

/* setInterval(() => {
    if (slide_proyecto_actual == slide_proyecto.length - 1) {
        slide_proyecto_actual = 0;
    } else {
        slide_proyecto_actual++;
    }

    $.muestraSlide();
}, 5000); */

function timer() {
    var timer = {
        running: false,
        iv: 5000,
        timeout: false,
        cb: function () { },
        start: function (cb, iv, sd) {
            var elm = this;
            clearInterval(this.timeout);
            this.running = true;
            if (cb) this.cb = cb;
            if (iv) this.iv = iv;
            if (sd) elm.execute(elm);
            this.timeout = setTimeout(function () {
                elm.execute(elm);
            }, this.iv);
        },
        execute: function (e) {
            if (!e.running) return false;
            e.cb();
            e.start();
        },
        stop: function () {
            this.running = false;
        },
        set_interval: function (iv) {
            clearInterval(this.timeout);
            this.start(false, iv);
        }
    };
    return timer;
}

let slide = new timer();
slide.start(
    function () {
        if (slide_proyecto_actual == slide_proyecto.length - 1) {
            slide_proyecto_actual = 0;
        } else {
            slide_proyecto_actual++;
        }

        slide.set_interval(7000);
        if (!slide_proyecto_actual) {
            slide.set_interval(15000);
        }

        $.muestraSlide();
    },
    15000,
    false
);

$.muestraSlide();
$("#slide-proyecto .dots a").on("click", function (e) {
    e.preventDefault();
    var item = $(this).data("item");

    slide_inicio_actual = item;
    $.muestraSlide();
});

if ($("body").hasClass("proyecto-depto")) {
    // DEPTOS
    $("#caracteristicas .items").slick({
        arrows: false,
        autoplay: true,
        dots: true,
        infinite: true,
        slidesToScroll: 1,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },

            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $(".contiene-plantas .slider").slick({
        arrows: true,
        autoplay: false,
        dots: false,
        infinite: false,
        slidesToScroll: 2,
        slidesToShow: 2,
        nextArrow:
            '<a href="javascript:void(null);" class="slick-arrow slick-next"></a>',
        prevArrow:
            '<a href="javascript:void(null);" class="slick-arrow slick-prev"></a>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
        console.log("e.target", e.target);
        $(".contiene-plantas .slider").slick("setPosition");
    });

    $("#detalles .slide").slick({
        arrows: true,
        autoplay: false,
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        nextArrow:
            '<a href="javascript:void(null);" class="slick-arrow slick-next"></a>',
        prevArrow:
            '<a href="javascript:void(null);" class="slick-arrow slick-prev"></a>'
    });

    $("#banner-griferia .slide").slick({
        arrows: false,
        autoplay: false,
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1
    });

    $("#banner-griferia")
        .find(".contiene-dots")
        .find("a")
        .on("click", function (e) {
            e.preventDefault();
            const target = $(this).attr("href");
            const index = $(target).data("index");
            console.log($(target));
            $("#banner-griferia .slide").slick("slickGoTo", index);
            $("#banner-griferia")
                .find(".contiene-dots")
                .find("a")
                .removeClass("active");
            $(this).addClass("active");
        });
}

// CASAS

if ($("body").hasClass("proyecto-casa")) {
    const carga = el => {
        el.addClass("cargado");
    };

    $(window).on("scroll", () => {
        if (
            $(window).scrollTop() >=
            $("#banner").offset().top - $(window).height() / 2 &&
            !$("#banner").hasClass("cargado")
        ) {
            carga($("#banner"));
            $("#banner .container").slideDown();
        }
    });

    $("#galeria .items")
        .slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            dots: false,
            prevArrow:
                '<a class="slick-arrow slick-arrow-prev" href="javascript:void(null);">&leftarrow;</a>',
            nextArrow:
                '<a class="slick-arrow slick-arrow-next" href="javascript:void(null);">&rightarrow;</a>'
        })
        .on("afterChange", function (event, slick, num) {
            const $current = $("#galeria .slick-current .imagen");
            const $titulo = $("#galeria .inferior-in");
            const titulo = $current.find("img").attr("alt");
            $titulo.html(titulo);
        });
}

function CargaVideo() {
    if ($(window).width() < 768) {
        $("#ParallaxVideo video source").attr("src", video_paralax_phone);
    } else {
        $("#ParallaxVideo video source").attr("src", video_paralax);
    }
}

$(document).ready(function () {
    if (
        typeof video_paralax != "undefined" &&
        typeof video_paralax_phone != "undefined"
    ) {
        CargaVideo();
        $(window).resize(function () {
            CargaVideo();
        });
    }
});

$(document).ready(function () {
    if (typeof borrar_clase != "undefined") {
        $(`.${borrar_clase}`).remove();
    }
});

if (document.querySelector("bci-widget")) {
    document
        .querySelector("bci-widget")
        .addEventListener("simulacion", event => {
            // tratamiento del evento simulación
            console.log(event.detail.rut); // Ejemplo de imprimir en consola
        });
    document
        .querySelector("bci-widget")
        .addEventListener("preaprobacion", event => {
            // tratamiento del evento preaprobación
            console.log(event.detail.rut); // Ejemplo de imprimir en consola
        });
    document
        .querySelector("bci-widget")
        .addEventListener("finalizacion", event => {
            // tratamiento del evento preaprobación
            console.log(event.detail.flujo); // Ejemplo de imprimir en consola
        });
}

$(document).ready(function () {
    $("#modal-ultimas-unidades").show();
    $("#modal-ultimas-unidades")
        .on("click", function () {
            $("#modal-ultimas-unidades").fadeOut();
        })
        .children()
        .click(function () {
            return false;
        });
    $("#modal-ultimas-unidades")
        .find(".btn-cerrar")
        .on("click", function () {
            $("#modal-ultimas-unidades").fadeOut();
        });
});

//SLIDE INICIO
$("#modelos .galeria-modelo").slick({
    arrows: false,
    autoplay: true,
    dots: false,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 4
});

// $("#galeria-item").slick({
//     arrows: false,
//     autoplay: true,
//     dots: false,
//     infinite: true,
//     slidesToScroll: 1,
//     slidesToShow: 3
// });

$('#en-promocion-getnet').find('.cerrar-promo').on('click', function () {
    $('#en-promocion-getnet').toggleClass('close');
})
$('.en-promocion').find('.cerrar-promo').on('click', function () {
    $(this).closest('.en-promocion').hide();
})

require("./modal_promocion");
require("./components/banner_promocion_04_24");

